import React, { useContext } from 'react';
import { Route } from "react-router-dom";

import { headers } from "../Data/headers";
import { Helmet } from 'react-helmet-async';
import { useCheckoutT } from "../i18n/checkout";

// The tab titles of the Spanish and Portuguese checkouts.
const CHECKOUT_TITLES = {
  es: {
    "/order/documents": "Detalles | eVerbary",
    "/order/options": "Entrega y extras | eVerbary",
    "/order/contact": "Contacto | eVerbary",
    "/order/payment": "Pago | eVerbary",
  },
  pt: {
    "/order/documents": "Detalhes | eVerbary",
    "/order/options": "Entrega e extras | eVerbary",
    "/order/contact": "Contato | eVerbary",
    "/order/payment": "Pagamento | eVerbary",
  },
};

function HeadedRoute({ children, ...rest }) {
  const { lang } = useCheckoutT();
  const title = (CHECKOUT_TITLES[lang] && CHECKOUT_TITLES[lang][rest.path]) || headers[rest.path]?.title || headers['default'].title;
  return (
    <Route
      {...rest}
      render={() => (
        <>
          <Helmet>
            <title>{title}</title>
            <meta
              name="description"
              content={headers[rest.path]?.description ?? headers['default'].description}
            />
            <meta name="robots" content="index,follow"/>
            <meta name="resource-type" content="document" />
            <meta name="distribution" content="global" />
            <meta name="revisit-after" content="1 days" />
            <meta name="rating" content="general" />
          </Helmet>
            {children}
        </>
      )}
    />
  );
}

export { HeadedRoute };